import React from 'react';
import { motion } from 'framer-motion';
export const Process: React.FC = () => {
  const steps = [{
    number: '01',
    title: 'Analizamos tu negocio',
    desc: 'Entendemos qué vendés y a quién.'
  }, {
    number: '02',
    title: 'Diseñamos tu página',
    desc: 'Creamos una estructura visual atractiva.'
  }, {
    number: '03',
    title: 'La dejamos lista',
    desc: 'Optimizada y funcionando para recibir clientes.'
  }];
  return <section id="proceso" className="py-24 relative z-10" data-id="element-161">
      <div className="max-w-7xl mx-auto px-6" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-163">
          <h2 className="text-3xl md:text-5xl font-bold" data-id="element-164">Cómo trabajamos</h2>
        </motion.div>

        <div className="relative" data-id="element-165">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-white/10 -translate-y-1/2 z-0" data-id="element-166" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-167">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-168">
                <div className="w-24 h-24 rounded-full bg-dark-bg border-2 border-neon-blue flex items-center justify-center box-glow mb-6 relative" data-id="element-169">
                  <span className="font-display text-3xl font-bold text-white" data-id="element-170">
                    {step.number}
                  </span>
                  {/* Decorative outer ring */}
                  <div className="absolute inset-[-10px] rounded-full border border-neon-blue/30 animate-[spin_10s_linear_infinite]" data-id="element-171" />
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-172">{step.title}</h3>
                <p className="text-silver" data-id="element-173">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};